import { KNOWLEDGE_BASE } from './knowledge-base.js';

export interface GuideArticle {
  id: string;
  title: string;
  popular?: boolean;
  content: string;
}

export interface GuideCategory {
  id: string;
  label: string;
  articles: GuideArticle[];
}

export interface GuideConfig {
  appContext: string;
  categories: GuideCategory[];
}

function kbContent(id: string): string {
  const section = KNOWLEDGE_BASE.find((s) => s.id === id);
  if (!section) return '';
  const sub = section.subsections?.map((s) => `### ${s.title}\n${s.content}`).join('\n\n') ?? '';
  return section.content + (sub ? '\n\n' + sub : '');
}

function kbSubContent(sectionId: string, subsectionId: string): string {
  const section = KNOWLEDGE_BASE.find((s) => s.id === sectionId);
  return section?.subsections?.find((s) => s.id === subsectionId)?.content ?? '';
}

export const EDISON_GUIDE_CONFIG: GuideConfig = {
  appContext: 'Edison, an R&DTI claim management platform for Australian businesses',
  categories: [
    {
      id: 'getting-started',
      label: 'Getting started',
      articles: [
        {
          id: 'platform-overview',
          title: 'What is Edison?',
          popular: true,
          content: kbContent('platform-overview'),
        },
        {
          id: 'getting-started-guide',
          title: 'Getting started step-by-step',
          content: kbSubContent('platform-overview', 'getting-started'),
        },
        {
          id: 'dashboard-guide',
          title: 'Dashboard overview',
          content: kbContent('dashboard'),
        },
      ],
    },
    {
      id: 'projects-and-tfa',
      label: 'Projects & TFA',
      articles: [
        {
          id: 'projects-guide',
          title: 'Managing projects',
          popular: true,
          content: kbContent('projects'),
        },
        {
          id: 'tfa-panel-guide',
          title: 'TFA Panel — Technical Feasibility Assessment',
          content: kbContent('tfa-panel'),
        },
        {
          id: 'tfa-deliberation-guide',
          title: 'TFA Panel Deliberation workbench',
          content: kbSubContent('tfa-panel', 'tfa-deliberation-workbench'),
        },
        {
          id: 'activities-guide',
          title: 'Activities & competence records',
          content: kbContent('activities'),
        },
      ],
    },
    {
      id: 'evidence',
      label: 'Evidence & signals',
      articles: [
        {
          id: 'evidence-vault-guide',
          title: 'Evidence Vault',
          content: kbContent('evidence-vault'),
        },
        {
          id: 'signals-guide',
          title: 'GitHub signals & automated ingestion',
          content: kbContent('signals'),
        },
      ],
    },
    {
      id: 'timewriting-and-claims',
      label: 'Timewriting & claims',
      articles: [
        {
          id: 'timewriting-guide',
          title: 'Reviewing and approving time entries',
          popular: true,
          content: kbContent('timewriting'),
        },
        {
          id: 'claims-guide',
          title: 'Creating and locking a claim',
          content: kbContent('claims'),
        },
        {
          id: 'audit-portal-guide',
          title: 'Audit Portal — external reviewer access',
          content: kbContent('audit-portal'),
        },
      ],
    },
    {
      id: 'admin-and-tools',
      label: 'Admin & tools',
      articles: [
        {
          id: 'grants-guide',
          title: 'Grant discovery & matching',
          content: kbContent('grants'),
        },
        {
          id: 'users-guide',
          title: 'Users & roles',
          content: kbContent('users'),
        },
        {
          id: 'keyboard-shortcuts-guide',
          title: 'Keyboard shortcuts',
          content: kbContent('keyboard-shortcuts'),
        },
        {
          id: 'troubleshooting-guide',
          title: 'Troubleshooting',
          content: kbContent('troubleshooting'),
        },
      ],
    },
  ],
};
